import {
    Flex,
    Heading,
    chakra,
    Box,
    Stack,
    Divider,
    Text,
    VStack,
} from '@chakra-ui/react';

import { Icon } from '@chakra-ui/react'
import { EmailIcon, PhoneIcon } from '@chakra-ui/icons';
import { AiFillHome } from 'react-icons/ai'
import { useLanguage } from '../i18n/LanguageContext';

const Contact = () => {
    const { isEnglish, t } = useLanguage();

    const contact_info = [{
        type: 'address',
        name: t('contact.address'),
        content: isEnglish
            ? `National Taiwan University\nNo. 1, Sec. 4, Roosevelt Rd., Taipei 10617, Taiwan\n• Room 542, Department of Computer Science and Information Engineering\n• Room R602, South Block, Tseng Jiang Hall`
            : `台北市羅斯福路四段一號 國立臺灣大學\n• 資訊工程系 542 室\n• 鄭江樓南棟 R602`
    },
    {
        type: 'email',
        name: t('contact.email'),
        content: 'EMAIL：tingyunc@ntu.edu.tw'
    },
    {
        type: 'phone',
        name: t('contact.phone'),
        content: isEnglish ? 'TEL：+886-2-3366-4888 ext. 542' : 'TEL：(02)3366-4888 #542'
    }]

    return (
        <Box
            bg="#edf3f8"
            p={20}
        >
            <chakra.h2
                py={5}
                fontSize={35}
                fontWeight={'bold'}
                mt={'8'}
                color={'gray'}>
                {t('contact.title')}
            </chakra.h2>
            <Divider />
            {/* RWD: md 以上版本 */}
            <Flex
                justifyContent={'space-around'}
                mt={10}
                display={{ base: 'none', md: 'flex' }}
            >
                {contact_info.map((item) => {
                    return (
                        <Box
                            bg={'white'}
                            boxShadow={'2xl'}
                            width={1 / 5}
                            rounded={'md'}
                            overflow={'hidden'}>
                            <Flex justify={'center'} mt={5}>
                                {item.type === 'email' ? (<EmailIcon w={10} h={10} />) : (item.type === 'address' ? <Icon as={AiFillHome} w={10} h={10} /> : <PhoneIcon w={10} h={10} />)}
                            </Flex>
                            <Box p={6}>
                                <Stack spacing={0} align={'center'} >
                                    <Heading fontSize={'2xl'} fontWeight={'bold'} fontFamily={'body'}>
                                        {item.name}
                                    </Heading>
                                </Stack>
                                <Text mt={3} whiteSpace="pre-line" textAlign="left">{item.content}</Text>
                            </Box>
                        </Box>
                    )
                })}
            </Flex>
            {/* RWD: md 以下版本 */}
            <VStack
                display={{ md: 'none' }}
            >
                {contact_info.map((item) => {
                    return (
                        <Box
                            bg={'white'}
                            boxShadow={'2xl'}
                            rounded={'md'}
                            overflow={'hidden'}>
                            <Flex justify={'space-around'} alignItems={'center'} >
                                {item.type === 'email' ? (<EmailIcon w={10} h={'100%'} />) : (item.type === 'address' ? <Icon as={AiFillHome} w={10} h={10} /> : <PhoneIcon w={10} h={10} />)}
                                <Box p={6} w={2 / 3}>
                                    <Stack spacing={0} align={'center'} >
                                        <Heading fontSize={'2xl'} fontWeight={'bold'} fontFamily={'body'}>
                                            {item.name}
                                        </Heading>
                                    </Stack>
                                    <Text mt={3} whiteSpace="pre-line" textAlign="left">{item.content}</Text>
                                </Box>
                            </Flex>
                        </Box>
                    )
                })}
            </VStack>
        </Box>
    )
}
export default Contact;
